import * as React from 'react';
import TopBanner from '../../components/TopBanner';

import './style.css';
import messages from './messages';
import {FormattedMessage} from 'react-intl';
import Icon from '../../components/Icon';

export class IncompatibleBrowserPrompt extends React.Component {
    static BROWSER_PROMPT_LOCAL_STORAGE_KEY = 'alva:incompatible-browser-prompt-seen';

    constructor(props) {
        super(props);
        this.state = {
            visible: this.isUnsupported() && !this.hasSeenPrompt()
        };
        this.closePrompt = this.closePrompt.bind(this);
    }

    isUnsupported() {
        const userAgent = window.navigator.userAgent;
        return this.isIeBeforeEdge(userAgent) || this.isBelowSafari11(userAgent);
    }

    /**
     * https://codepen.io/gapcode/pen/vEJNZN
     */
    isIeBeforeEdge(userAgent) {
        return this.isIe10OrOlder(userAgent) || this.isIe11(userAgent);
    }

    isIe10OrOlder(userAgent) {
        const msie = userAgent.indexOf('MSIE ');

        return msie > 0;
    }

    isIe11(userAgent) {
        const trident = userAgent.indexOf('Trident/');

        return trident > 0;
    }

    isBelowSafari11(userAgent) {
        let regex = /Mac OS X.*Version\/([0-9]+)\.[0-9]+\.[0-9]+ Safari\//;
        let matches = userAgent.match(regex);
        if (matches) {
            return Number(matches[1]) < 11;
        }
        return false;
    }

    closePrompt() {
        this.setState({visible: false});
        this.markPromptAsSeen();
    }

    hasSeenPrompt() {
        return localStorage.getItem(IncompatibleBrowserPrompt.BROWSER_PROMPT_LOCAL_STORAGE_KEY) === 'true';
    }

    markPromptAsSeen() {
        localStorage.setItem(IncompatibleBrowserPrompt.BROWSER_PROMPT_LOCAL_STORAGE_KEY, 'true');
    }

    browserLinks = () => ({
        chromeLink: <a rel='noreferrer noopener' target='_blank' href='https://chrome.google.com'>Chrome</a>,
        edgeLink: <a rel='noreferrer noopener' target='_blank' href='https://microsoft-edge.en.softonic.com/download'>Microsoft Edge</a>
    });

    render() {
        return (
            <TopBanner visible={this.state.visible}>
                <p>
                    <FormattedMessage {...messages.incompatibleBrowser} values={this.browserLinks()}/>
                    <a onClick={this.closePrompt}><Icon iconStyle={{color: '#fff'}} className='is-pulled-right' icon='close'/></a>
                </p>
            </TopBanner>
        );
    }
}
